import React from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";
import firebase from '../../../firebase';

export default class UserActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };

    this.toggleUserActions = this.toggleUserActions.bind(this);
    this.logout = this.logout.bind(this);
  }

  logout=()=>{
    firebase.auth().signOut().then(function() {
        // Sign-out successful.
        console.log("signed out succesfully");
  }).catch(function(error) {
    // An error happened.
    console.log("erro while signing out "+error);
  });
  }

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible
    });
  }

  render() {
    return (
      <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
        <div className="text-nowrap px-3">
                   <a className="d-none d-md-inline-block" style={{marginTop:'40%'}} href="#" onClick={this.logout}>Logout</a>
        </div>
       
      </NavItem>
    );
  }
}
